import {
  Male as MaleIcon,
  Female as FemaleIcon,
  HelpOutline,
} from "@mui/icons-material";

const ICON_MAP = {
  // Gender
  male: MaleIcon,
  female: FemaleIcon,
};

export const GenderIcon = ({ iconKey, ...props }) => {
  const IconComponent = ICON_MAP[iconKey] || HelpOutline;
  return <IconComponent fontSize="inherit" {...props} />;
};
